import { ProductTypeEnum } from '@systemeio/digital-store-shared'
import { getLanguageCodeByLocale } from '@systemeio/ui'
import ContentSkeleton from 'modules/stores/store/components/content-skeleton'
import StoreEditDesign from 'modules/stores/store/components/design/store-edit-design'
import StoreContent from 'modules/stores/store/components/store-content'
import StoreEdit from 'modules/stores/store/components/store-edit'
import StoreLocoWrapper from 'modules/stores/store/components/store-loco-wrapper'
import LinkEdit from 'modules/stores/store/content/link/link-edit'
import { LinkItemViewType } from 'modules/stores/store/content/link/types/link-interface'
import OptinEdit from 'modules/stores/store/content/optin/optin-edit'
import { OptinItemViewType } from 'modules/stores/store/content/optin/types/optin-interface'
import ProductEdit from 'modules/stores/store/content/product/digital-product/product-download/edit'
import Edit from 'modules/stores/store/content/product/digital-product/product-e-course/edit'
import PhysicalProductEdit from 'modules/stores/store/content/product/physical-product/edit'
import {
  PhysicalProductItemViewType,
  ProductDownloadItemViewType,
  ProductECourseItemViewType,
} from 'modules/stores/store/content/product/types/product-interface'
import ProfileEdit from 'modules/stores/store/content/profile/profile-edit'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { useRouter } from 'next/router'
import { FC } from 'react'

const ContentWrapper: FC = () => {
  const { tab, storeId, itemId, productType } = useStoreQuery()

  const { data: storeView } = useStore(storeId)

  const { isReady } = useRouter()

  let content

  if (storeView && isReady) {
    const item = storeView.items.find(item => item.itemId === itemId)

    const languageCode = getLanguageCodeByLocale(storeView.locale)

    switch (tab) {
      case StoreTabEnum.profile:
        content = <ProfileEdit store={storeView} />
        break
      case StoreTabEnum.link: {
        content = (
          <StoreLocoWrapper languageCode={languageCode}>
            <LinkEdit
              storeId={storeView.id}
              link={item as LinkItemViewType}
              languageCode={languageCode}
            />
          </StoreLocoWrapper>
        )
        break
      }
      case StoreTabEnum.optin: {
        content = (
          <StoreLocoWrapper languageCode={languageCode}>
            <OptinEdit
              storeId={storeView.id}
              optin={item as OptinItemViewType | undefined}
              languageCode={languageCode}
            />
          </StoreLocoWrapper>
        )

        break
      }
      case StoreTabEnum.product: {
        switch (productType) {
          case ProductTypeEnum.download:
            content = (
              <StoreLocoWrapper languageCode={languageCode}>
                <ProductEdit
                  storeId={storeView.id}
                  item={item as ProductDownloadItemViewType | undefined}
                  languageCode={languageCode}
                />
              </StoreLocoWrapper>
            )
            break
          case ProductTypeEnum.eCourse:
            content = (
              <StoreLocoWrapper languageCode={languageCode}>
                <Edit
                  storeId={storeView.id}
                  item={item as ProductECourseItemViewType | undefined}
                  languageCode={languageCode}
                />
              </StoreLocoWrapper>
            )
            break
          case ProductTypeEnum.physicalProduct:
            content = (
              <StoreLocoWrapper languageCode={languageCode}>
                <PhysicalProductEdit
                  storeId={storeView.id}
                  item={item as PhysicalProductItemViewType | undefined}
                  languageCode={languageCode}
                />
              </StoreLocoWrapper>
            )
        }
        break
      }
      case StoreTabEnum.theme: {
        content = <StoreEditDesign store={storeView} />
        break
      }
      case StoreTabEnum.storeSettings: {
        content = <StoreEdit store={storeView} />
        break
      }
      default:
        content = <StoreContent storeView={storeView} />
    }
  } else {
    content = <ContentSkeleton />
  }

  return <div className={'flex w-full flex-col lg:max-w-[calc(100%-360px-20px)]'}>{content}</div>
}

export default ContentWrapper
